import { Address, BasisType, CustomerType } from "@raskrask-dk/raskrask-utils";
import {ChooseNoAvailable} from "../../action/generalActions/choosenotavailable.action";
import {Next, SetBasisType, SetCustomerType} from "./actions";
export type BasisTypeAction = Next | SetCustomerType | SetBasisType | ChooseNoAvailable;

export const basistypesActions = [Next, SetCustomerType, SetBasisType, ChooseNoAvailable] as const;

export type basisActions = (typeof basistypesActions)[number];

export interface IGetData {
  address: Address;
  basisType: BasisType | undefined;
  customerType: CustomerType | undefined;
}

export interface BasisStateDependencies {
  address: Address;
  basisType?: BasisType;
  customerType?: CustomerType;
}
